import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../data/site";

export const WhatsAppFab = () => {
  return (
    <motion.a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 pl-4 pr-5 py-3.5 rounded-full text-white shadow-lg group"
      style={{ backgroundColor: "#1FA855" }}
      aria-label="Chat on WhatsApp"
    >
      <span className="relative flex h-3 w-3">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white/60" />
      </span>
      <MessageCircle className="h-5 w-5" strokeWidth={2} />
      <span className="text-sm font-medium tracking-wide hidden sm:inline">Enquire</span>
    </motion.a>
  );
};
